/**
 * Invoice List Translations
 * =========================
 * Column headers, categories, upload modal, export modal
 */

import { Translations } from '../shared/i18n';

export const invoiceListTranslations: Translations = {
    tr: {
        // Page
        expensesTitle: 'Harcamalar',
        expensesDescription: 'OCR ile çıkarılan harcama detaylarını görüntüleyiniz',
        revenueTitle: 'Gelirler',
        revenueDescription: 'Gelir faturalarınızı yükleyin ve yönetin',
        navRevenue: 'Gelirler',

        // Columns
        colFilename: 'Dosya Adı',
        colSupplier: 'Tedarikçi',
        colExpenseCategory: 'Gider Türü',
        colTaxId: 'Vergi No',
        colAddress: 'Adres',
        colInvoiceNumber: 'Fatura No',
        colInvoiceDate: 'Fatura Tarihi',
        colExpenseDate: 'Gider Tarihi',
        colRevenueDate: 'Gelir Tarihi',
        colRevenueCategory: 'Gelir Türü',
        colMatched: 'Eşleşme',
        colStatus: 'Durum',
        exportYes: 'Evet',
        exportNo: 'Hayır',
        exportSelectionHint: '{count} seçili kayıt export edilecek. Tarih aralığı uygulanmaz.',
        exportIncludeDuplicates: 'Kopya olarak işaretlenen kayıtlar da export edilsin',
        colDueDate: 'Vade Tarihi',
        colTotalAmount: 'Toplam Gider',
        colCurrency: 'Para Birimi',
        colTax: 'KDV',
        colNetAmount: 'Net Tutar',
        colConvertedAmount: 'Dönüştürülmüş Tutar',
        colLineItems: 'Kalem Sayısı',
        colCreatedAt: 'Yüklenme',
        displayCurrency: 'Görüntüleme Para Birimi',

        // Actions
        view: 'Görüntüle',
        viewTooltipSingle: 'Tek bir fatura seçiniz',
        viewTooltipReady: 'Fatura detayını görüntüle',
        bulkUpload: 'Gider Yükle',
        deleteTitle: 'Çöp Kutusuna Taşı',
        deleteConfirmMsg: '{count} fatura çöp kutusuna taşınacak. 30 gün içinde geri yükleyebilirsiniz.',
        deleteMatchWarning: 'Eşleştirmesi olan belgeler silinirse eşleştirmeleri de kaldırılacaktır.',
        deleteConfirmLabel: 'Çöp Kutusuna Taşı',
        deleteCancelLabel: 'Vazgeç',
        deleteError: 'Silme sırasında bir hata oluştu.',
        exportError: 'Export sırasında bir hata oluştu.',
        fetchError: 'Faturalar alınamadı',
        errorConnecting: 'Sunucuya bağlanırken hata oluştu',

        // Processing banner
        processingCount: '{count} fatura işleniyor...',
        statusProcessing: 'İşleniyor',
        statusPending: 'Bekliyor',
        cancelProcessing: 'İptal',
        retry: 'Tekrar Dene',
        dismiss: 'Kaldır',
        statusFailed: 'Başarısız',
        statusCancelled: 'İptal Edildi',
        failedCount: '{count} belge başarısız',
        cancelledCount: '{count} belge iptal edildi',

        // Inline dropzone
        dropzoneInline: 'Dosyaları sürükleyin veya tıklayarak yükleyin',
        dropzoneInlineHover: 'Dosyaları buraya bırakın',

        // Unsaved changes
        unsavedTitle: 'Kaydedilmemiş Değişiklikler',
        unsavedMessage: 'Kaydedilmemiş değişiklikleriniz var. Sayfadan ayrılırsanız bu değişiklikler kaybolacak.',
        unsavedLeave: 'Ayrıl',
        unsavedStay: 'Kal',

        // Upload modal
        uploadTitle: 'Gider Yükleme',
        dropzoneText: 'Dosyaları sürükleyin veya seçmek için tıklayın',
        dropzoneHover: 'Dosyaları buraya bırakın',
        dropzoneHint: 'PDF, PNG, JPG, WEBP, HEIC, GIF, BMP, TIFF (max 10MB)',
        filesSelected: '{count} dosya seçildi',
        clearAll: 'Tümünü Temizle',
        uploadButton: '{count} Dosya Yükle',
        cancelUpload: 'İptal Et',
        uploadProgress: '{done} / {total} dosya yüklendi',
        uploadSuccess: '{count} başarılı',
        uploadError: '{count} hatalı',
        uploadPending: '{count} bekliyor',
        invalidFileType: 'Geçersiz dosya tipi. İzin verilen: {types}',
        fileTooLarge: 'Dosya çok büyük. Maksimum: {size}MB',
        uploadFailed: 'Yükleme başarısız',
        uploadErrorGeneric: 'Yükleme hatası',
        uploadBeforeUnload: 'Yükleme devam ediyor. Sayfadan çıkmak istediğinize emin misiniz?',
        uploadCancelConfirm: 'Yükleme devam ediyor. İptal etmek istediğinize emin misiniz?\nYüklenmiş dosyalar kalacak, bekleyenler iptal edilecek.',
        uploadDoneTitle: 'Dosyalar yüklendi!',
        uploadDoneMessage: 'OCR ve analiz arka planda devam ediyor. Güvenle sayfadan ayrılabilir veya modalı kapatabilirsiniz.',

        // Export modal
        exportTitle: 'Dışa Aktar',
        exportStepFormat: 'Format',
        exportStepSheets: 'Sayfa Düzeni',
        exportStepDates: 'Tarih Aralığı',
        exportSheetTitle: 'Excel nasıl düzenlensin?',
        exportSheetDesc: 'Verilerin sayfalara nasıl bölüneceğini seçin. Örneğin "1 Ay" her ay için ayrı sayfa oluşturur (Oca, Şub...), "3 Ay" çeyrek dönemlik gruplar.',
        sheetInterval1: '1 Ay',
        sheetInterval2: '2 Ay',
        sheetInterval3: 'Çeyrek Dönem',
        sheetInterval6: 'Yarı Yıl',
        sheetInterval12: 'Tam Yıl',
        sheetIntervalCustom: 'Özel',
        customMonthsLabel: 'Sayfa başına ay:',
        customMonthsHint: '(1-24 arası)',
        exportDateTitle: 'Tarih Aralığı Seçin',
        exportDateDesc: 'Sadece bu tarih aralığındaki veriler Excel\'e dahil edilecektir.',
        startDate: 'Başlangıç Tarihi',
        endDate: 'Bitiş Tarihi',
        exportSheetInterval: 'Sayfa aralığı:',
        exportMonthsUnit: 'ay',
        exportEstimatedSheets: 'Tahmini sayfa sayısı:',
        exportSheetsUnit: 'sayfa',
        exportNext: 'İleri',
        exportBack: 'Geri',
        preparing: 'Hazırlanıyor...',
        downloadExcel: 'Excel İndir',
        downloadDatev: 'DATEV Dosyası İndir',
        exportFormatTitle: 'Dışa Aktarma Formatı',
        exportFormatDesc: 'Hangi formatta dışa aktarmak istiyorsunuz?',
        exportFormatExcelDesc: 'Elektronik tablo olarak dışa aktar',
        exportFormatDatevDesc: 'Mali müşaviriniz için DATEV formatında',
        exportDatevStep: 'DATEV Ayarları',
        exportDatevStepDesc: 'DATEV dışa aktarma ayarlarınızı doğrulayın.',
        exportDatevMissing: 'DATEV ayarları yapılmamış. Lütfen önce Beraternummer ve Mandantennummer girin.',
        exportDatevGoSettings: 'Ayarlara git',
        colSachkonto: 'Sachkonto',

        // Manual entry
        manualEntry: 'Manuel Ekle',
        manualEntryTitle: 'Manuel Belge Oluştur',
        manualEntryExpenseTitle: 'Manuel Gider Oluştur',
        manualEntryRevenueTitle: 'Manuel Gelir Oluştur',
        manualFieldInvoiceDate: 'Fatura Tarihi',
        manualFieldDueDate: 'Vade Tarihi',
        manualFieldSupplierName: 'Tedarikçi Adı',
        manualFieldTotalAmount: 'Toplam Tutar',
        manualFieldCurrency: 'Para Birimi',
        manualFieldCategory: 'Kategori',
        manualFieldInvoiceNumber: 'Fatura No',
        manualFieldDescription: 'Açıklama',
        manualFieldVat: 'KDV Tutarı',
        manualCreate: 'Oluştur',
        manualCreating: 'Oluşturuluyor...',
        manualCreateSuccess: 'Belge başarıyla oluşturuldu',
        manualCreateError: 'Belge oluşturulurken hata oluştu',
        manualRequired: 'Bu alan zorunludur',
        manualInvalidDate: 'Geçerli bir tarih giriniz',
        manualInvalidAmount: 'Geçerli bir tutar giriniz',
        manualSelectCategory: 'Kategori seçiniz',
        manualSelectCurrency: 'Para birimi seçiniz',

        // Duplicate detection
        colDuplicate: 'Tekrar',
        duplicateBadge: 'Kopya',
        documentDuplicate: 'Bu dok\u00fcman ba\u015fka bir y\u00fcklemeyle ayn\u0131 g\u00f6r\u00fcn\u00fcyor',
        markDuplicate: 'Kopya olarak i\u015faretle',
        unmarkDuplicate: '\u0130\u015fareti kald\u0131r',

        // Export data labels
        exportFilename: 'Dosya Adi',
        exportSupplier: 'Tedarikci',
        exportInvoiceNo: 'Fatura No',
        exportInvoiceDate: 'Fatura Tarihi',
        exportTotalAmount: 'Toplam Tutar',
        exportCurrency: 'Para Birimi',
        exportVat: 'KDV',
        exportSubtotal: 'Alt Toplam',
        exportLineItems: 'Kalem Sayisi',
        exportExtractionStatus: 'Extraction Durumu',
        exportUploadDate: 'Yuklenme Tarihi',
        exportStatusCompleted: 'Tamamlandi',
        exportStatusProcessing: 'Isleniyor',
        exportStatusPending: 'Bekliyor',
        exportStatusFailed: 'Basarisiz',
        exportStatusUnknown: 'Bilinmiyor',
        exportPeriod: 'Donem',
        exportInvoiceCount: 'Fatura Sayisi',
        exportSummarySheet: 'Ozet',
        exportNoData: 'Secilen tarih araliginda fatura bulunamadi.',
        exportFilenamePrefix: 'Harcamalar_',
        exportMonths: 'Ocak,Subat,Mart,Nisan,Mayis,Haziran,Temmuz,Agustos,Eylul,Ekim,Kasim,Aralik',
    },
    en: {
        // Page
        expensesTitle: 'Expenses',
        expensesDescription: 'View expense details extracted via OCR',
        revenueTitle: 'Revenues',
        revenueDescription: 'Upload and manage your revenues',
        navRevenue: 'Revenues',

        // Columns
        colFilename: 'Filename',
        colSupplier: 'Supplier',
        colExpenseCategory: 'Expense Category',
        colTaxId: 'Tax ID',
        colAddress: 'Address',
        colInvoiceNumber: 'Invoice No',
        colInvoiceDate: 'Invoice Date',
        colExpenseDate: 'Expense Date',
        colRevenueDate: 'Revenue Date',
        colRevenueCategory: 'Revenue Category',
        colMatched: 'Matched',
        colStatus: 'Status',
        exportYes: 'Yes',
        exportNo: 'No',
        exportSelectionHint: '{count} selected items will be exported. Date range is not applied.',
        exportIncludeDuplicates: 'Also include items flagged as duplicates',
        colDueDate: 'Due Date',
        colTotalAmount: 'Total Expense',
        colCurrency: 'Currency',
        colTax: 'VAT',
        colNetAmount: 'Net Amount',
        colConvertedAmount: 'Converted Amount',
        colLineItems: 'Line Items',
        colCreatedAt: 'Uploaded',
        displayCurrency: 'Display Currency',

        // Actions
        view: 'View',
        viewTooltipSingle: 'Select a single invoice',
        viewTooltipReady: 'View invoice details',
        bulkUpload: 'Upload Expense',
        deleteTitle: 'Move to Trash',
        deleteConfirmMsg: '{count} invoice(s) will be moved to trash. You can restore them within 30 days.',
        deleteMatchWarning: 'If any of these documents have matches, the matches will also be removed.',
        deleteConfirmLabel: 'Move to Trash',
        deleteCancelLabel: 'Cancel',
        deleteError: 'An error occurred while deleting.',
        exportError: 'An error occurred during export.',
        fetchError: 'Failed to fetch invoices',
        errorConnecting: 'Error connecting to server',

        // Processing banner
        processingCount: '{count} invoice(s) processing...',
        statusProcessing: 'Processing',
        statusPending: 'Pending',
        cancelProcessing: 'Cancel',
        retry: 'Retry',
        dismiss: 'Dismiss',
        statusFailed: 'Failed',
        statusCancelled: 'Cancelled',
        failedCount: '{count} document(s) failed',
        cancelledCount: '{count} document(s) cancelled',

        // Inline dropzone
        dropzoneInline: 'Drag files here or click to upload',
        dropzoneInlineHover: 'Drop files here',

        // Unsaved changes
        unsavedTitle: 'Unsaved Changes',
        unsavedMessage: 'You have unsaved changes. If you leave this page, your changes will be lost.',
        unsavedLeave: 'Leave',
        unsavedStay: 'Stay',

        // Upload modal
        uploadTitle: 'Upload Expenses',
        dropzoneText: 'Drag files or click to select',
        dropzoneHover: 'Drop files here',
        dropzoneHint: 'PDF, PNG, JPG, WEBP, HEIC, GIF, BMP, TIFF (max 10MB)',
        filesSelected: '{count} file(s) selected',
        clearAll: 'Clear All',
        uploadButton: 'Upload {count} File(s)',
        cancelUpload: 'Cancel',
        uploadProgress: '{done} / {total} files uploaded',
        uploadSuccess: '{count} successful',
        uploadError: '{count} failed',
        uploadPending: '{count} pending',
        invalidFileType: 'Invalid file type. Allowed: {types}',
        fileTooLarge: 'File too large. Maximum: {size}MB',
        uploadFailed: 'Upload failed',
        uploadErrorGeneric: 'Upload error',
        uploadBeforeUnload: 'Upload in progress. Are you sure you want to leave?',
        uploadCancelConfirm: 'Upload in progress. Are you sure you want to cancel?\nUploaded files will be kept, pending files will be cancelled.',
        uploadDoneTitle: 'Files uploaded!',
        uploadDoneMessage: 'OCR and analysis continue in the background. You can safely leave or close this dialog.',

        // Export modal
        exportTitle: 'Export',
        exportStepFormat: 'Format',
        exportStepSheets: 'Organize Sheets',
        exportStepDates: 'Date Range',
        exportSheetTitle: 'How should your Excel be organized?',
        exportSheetDesc: 'Choose how to split data across sheets. Example: "1 Month" = one sheet per month (Jan, Feb...), "3 Months" = one sheet per quarter.',
        sheetInterval1: '1 Month',
        sheetInterval2: '2 Months',
        sheetInterval3: 'Quarterly',
        sheetInterval6: 'Half-Year',
        sheetInterval12: 'Full Year',
        sheetIntervalCustom: 'Custom',
        customMonthsLabel: 'Months per sheet:',
        customMonthsHint: '(1-24)',
        exportDateTitle: 'Select Date Range',
        exportDateDesc: 'Only data within this date range will be included in the export.',
        startDate: 'Start Date',
        endDate: 'End Date',
        exportSheetInterval: 'Sheet interval:',
        exportMonthsUnit: 'month(s)',
        exportEstimatedSheets: 'Estimated sheets:',
        exportSheetsUnit: 'sheet(s)',
        exportNext: 'Next',
        exportBack: 'Back',
        preparing: 'Preparing...',
        downloadExcel: 'Download Excel',
        downloadDatev: 'Download DATEV File',
        exportFormatTitle: 'Export Format',
        exportFormatDesc: 'Which format would you like to export?',
        exportFormatExcelDesc: 'Export as spreadsheet',
        exportFormatDatevDesc: 'DATEV format for your tax advisor',
        exportDatevStep: 'DATEV Settings',
        exportDatevStepDesc: 'Verify your DATEV export settings.',
        exportDatevMissing: 'DATEV settings not configured. Please enter Beraternummer and Mandantennummer first.',
        exportDatevGoSettings: 'Go to Settings',
        colSachkonto: 'Sachkonto',

        // Manual entry
        manualEntry: 'Create Manually',
        manualEntryTitle: 'Create Manual Document',
        manualEntryExpenseTitle: 'Create Manual Expense',
        manualEntryRevenueTitle: 'Create Manual Revenue',
        manualFieldInvoiceDate: 'Invoice Date',
        manualFieldDueDate: 'Due Date',
        manualFieldSupplierName: 'Supplier Name',
        manualFieldTotalAmount: 'Total Amount',
        manualFieldCurrency: 'Currency',
        manualFieldCategory: 'Category',
        manualFieldInvoiceNumber: 'Invoice No',
        manualFieldDescription: 'Description',
        manualFieldVat: 'VAT Amount',
        manualCreate: 'Create',
        manualCreating: 'Creating...',
        manualCreateSuccess: 'Document created successfully',
        manualCreateError: 'Failed to create document',
        manualRequired: 'This field is required',
        manualInvalidDate: 'Please enter a valid date',
        manualInvalidAmount: 'Please enter a valid amount',
        manualSelectCategory: 'Select a category',
        manualSelectCurrency: 'Select a currency',

        // Duplicate detection
        colDuplicate: 'Duplicate',
        duplicateBadge: 'Duplicate',
        documentDuplicate: 'This document appears to be a duplicate',
        markDuplicate: 'Mark as duplicate',
        unmarkDuplicate: 'Remove mark',

        // Export data labels
        exportFilename: 'Filename',
        exportSupplier: 'Supplier',
        exportInvoiceNo: 'Invoice No',
        exportInvoiceDate: 'Invoice Date',
        exportTotalAmount: 'Total Amount',
        exportCurrency: 'Currency',
        exportVat: 'VAT',
        exportSubtotal: 'Subtotal',
        exportLineItems: 'Line Items',
        exportExtractionStatus: 'Extraction Status',
        exportUploadDate: 'Upload Date',
        exportStatusCompleted: 'Completed',
        exportStatusProcessing: 'Processing',
        exportStatusPending: 'Pending',
        exportStatusFailed: 'Failed',
        exportStatusUnknown: 'Unknown',
        exportPeriod: 'Period',
        exportInvoiceCount: 'Invoice Count',
        exportSummarySheet: 'Summary',
        exportNoData: 'No invoices found in the selected date range.',
        exportFilenamePrefix: 'Expenses_',
        exportMonths: 'January,February,March,April,May,June,July,August,September,October,November,December',
    },
    de: {
        // Page
        expensesTitle: 'Ausgaben',
        expensesDescription: 'Per OCR erfasste Ausgabendetails anzeigen',
        revenueTitle: 'Einnahmen',
        revenueDescription: 'Laden Sie Ihre Einnahmenrechnungen hoch und verwalten Sie sie',
        navRevenue: 'Einnahmen',

        // Columns
        colFilename: 'Dateiname',
        colSupplier: 'Lieferant',
        colExpenseCategory: 'Ausgabenkategorie',
        colTaxId: 'Steuer-Nr.',
        colAddress: 'Adresse',
        colInvoiceNumber: 'Rechnungs-Nr.',
        colInvoiceDate: 'Rechnungsdatum',
        colExpenseDate: 'Ausgabendatum',
        colRevenueDate: 'Umsatzdatum',
        colRevenueCategory: 'Umsatzkategorie',
        colMatched: 'Abgestimmt',
        colStatus: 'Status',
        exportYes: 'Ja',
        exportNo: 'Nein',
        exportSelectionHint: '{count} ausgewählte Einträge werden exportiert. Datumsbereich wird nicht angewendet.',
        exportIncludeDuplicates: 'Als Duplikate markierte Einträge ebenfalls exportieren',
        colDueDate: 'Fälligkeitsdatum',
        colTotalAmount: 'Gesamtausgaben',
        colCurrency: 'Währung',
        colTax: 'MwSt',
        colNetAmount: 'Nettobetrag',
        colConvertedAmount: 'Umgerechneter Betrag',
        colLineItems: 'Positionen',
        colCreatedAt: 'Hochgeladen',
        displayCurrency: 'Anzeigewährung',

        // Actions
        view: 'Anzeigen',
        viewTooltipSingle: 'Bitte eine einzelne Rechnung auswählen',
        viewTooltipReady: 'Rechnungsdetails anzeigen',
        bulkUpload: 'Ausgabe hochladen',
        deleteTitle: 'In den Papierkorb verschieben',
        deleteConfirmMsg: '{count} Rechnung(en) werden in den Papierkorb verschoben. Sie können sie innerhalb von 30 Tagen wiederherstellen.',
        deleteMatchWarning: 'Falls Dokumente Abgleiche haben, werden diese ebenfalls entfernt.',
        deleteConfirmLabel: 'In den Papierkorb',
        deleteCancelLabel: 'Abbrechen',
        deleteError: 'Beim Löschen ist ein Fehler aufgetreten.',
        exportError: 'Beim Export ist ein Fehler aufgetreten.',
        fetchError: 'Rechnungen konnten nicht abgerufen werden',
        errorConnecting: 'Fehler bei der Verbindung zum Server',

        // Processing banner
        processingCount: '{count} Rechnung(en) werden verarbeitet...',
        statusProcessing: 'Wird verarbeitet',
        statusPending: 'Ausstehend',
        cancelProcessing: 'Abbrechen',
        retry: 'Wiederholen',
        dismiss: 'Entfernen',
        statusFailed: 'Fehlgeschlagen',
        statusCancelled: 'Abgebrochen',
        failedCount: '{count} Dokument(e) fehlgeschlagen',
        cancelledCount: '{count} Dokument(e) abgebrochen',

        // Inline dropzone
        dropzoneInline: 'Dateien hierher ziehen oder klicken zum Hochladen',
        dropzoneInlineHover: 'Dateien hier ablegen',

        // Unsaved changes
        unsavedTitle: 'Nicht gespeicherte Änderungen',
        unsavedMessage: 'Sie haben nicht gespeicherte Änderungen. Wenn Sie diese Seite verlassen, gehen Ihre Änderungen verloren.',
        unsavedLeave: 'Verlassen',
        unsavedStay: 'Bleiben',

        // Upload modal
        uploadTitle: 'Ausgaben hochladen',
        dropzoneText: 'Dateien hierher ziehen oder klicken zum Auswählen',
        dropzoneHover: 'Dateien hier ablegen',
        dropzoneHint: 'PDF, PNG, JPG, WEBP, HEIC, GIF, BMP, TIFF (max. 10 MB)',
        filesSelected: '{count} Datei(en) ausgewählt',
        clearAll: 'Alle entfernen',
        uploadButton: '{count} Datei(en) hochladen',
        cancelUpload: 'Abbrechen',
        uploadProgress: '{done} / {total} Dateien hochgeladen',
        uploadSuccess: '{count} erfolgreich',
        uploadError: '{count} fehlgeschlagen',
        uploadPending: '{count} ausstehend',
        invalidFileType: 'Ungültiger Dateityp. Erlaubt: {types}',
        fileTooLarge: 'Datei zu groß. Maximum: {size} MB',
        uploadFailed: 'Upload fehlgeschlagen',
        uploadErrorGeneric: 'Upload-Fehler',
        uploadBeforeUnload: 'Upload läuft. Möchten Sie die Seite wirklich verlassen?',
        uploadCancelConfirm: 'Upload läuft. Möchten Sie wirklich abbrechen?\nBereits hochgeladene Dateien bleiben erhalten, ausstehende werden abgebrochen.',
        uploadDoneTitle: 'Dateien hochgeladen!',
        uploadDoneMessage: 'OCR und Analyse laufen im Hintergrund weiter. Sie können die Seite sicher verlassen oder diesen Dialog schließen.',

        // Export modal
        exportTitle: 'Exportieren',
        exportStepFormat: 'Format',
        exportStepSheets: 'Blattintervall',
        exportStepDates: 'Datumsbereich',
        exportSheetTitle: 'Blattgruppierung',
        exportSheetDesc: 'Wie viele Monate Daten möchten Sie pro Excel-Blatt anzeigen?',
        sheetInterval1: '1 Monat',
        sheetInterval2: '2 Monate',
        sheetInterval3: '3 Monate',
        sheetInterval6: '6 Monate',
        sheetInterval12: '1 Jahr',
        sheetIntervalCustom: 'Benutzerdefiniert',
        customMonthsLabel: 'Monate:',
        customMonthsHint: '(1-24)',
        exportDateTitle: 'Datumsbereich',
        exportDateDesc: 'Welchen Zeitraum der Ausgaben möchten Sie exportieren?',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        exportSheetInterval: 'Blattintervall:',
        exportMonthsUnit: 'Monat(e)',
        exportEstimatedSheets: 'Geschätzte Blätter:',
        exportSheetsUnit: 'Blatt/Blätter',
        exportNext: 'Weiter',
        exportBack: 'Zurück',
        preparing: 'Wird vorbereitet...',
        downloadExcel: 'Excel herunterladen',
        downloadDatev: 'DATEV-Datei herunterladen',
        exportFormatTitle: 'Exportformat',
        exportFormatDesc: 'In welchem Format möchten Sie exportieren?',
        exportFormatExcelDesc: 'Als Tabellenkalkulation exportieren',
        exportFormatDatevDesc: 'DATEV-Format für Ihren Steuerberater',
        exportDatevStep: 'DATEV-Einstellungen',
        exportDatevStepDesc: 'Überprüfen Sie Ihre DATEV-Exporteinstellungen.',
        exportDatevMissing: 'DATEV-Einstellungen nicht konfiguriert. Bitte geben Sie zuerst Beraternummer und Mandantennummer ein.',
        exportDatevGoSettings: 'Zu den Einstellungen',
        colSachkonto: 'Sachkonto',

        // Manual entry
        manualEntry: 'Manuell erstellen',
        manualEntryTitle: 'Dokument manuell erstellen',
        manualEntryExpenseTitle: 'Ausgabe manuell erstellen',
        manualEntryRevenueTitle: 'Einnahme manuell erstellen',
        manualFieldInvoiceDate: 'Rechnungsdatum',
        manualFieldDueDate: 'Fälligkeitsdatum',
        manualFieldSupplierName: 'Lieferantenname',
        manualFieldTotalAmount: 'Gesamtbetrag',
        manualFieldCurrency: 'Währung',
        manualFieldCategory: 'Kategorie',
        manualFieldInvoiceNumber: 'Rechnungs-Nr.',
        manualFieldDescription: 'Beschreibung',
        manualFieldVat: 'MwSt-Betrag',
        manualCreate: 'Erstellen',
        manualCreating: 'Wird erstellt...',
        manualCreateSuccess: 'Dokument erfolgreich erstellt',
        manualCreateError: 'Fehler beim Erstellen des Dokuments',
        manualRequired: 'Dieses Feld ist erforderlich',
        manualInvalidDate: 'Bitte geben Sie ein gültiges Datum ein',
        manualInvalidAmount: 'Bitte geben Sie einen gültigen Betrag ein',
        manualSelectCategory: 'Kategorie auswählen',
        manualSelectCurrency: 'Währung auswählen',

        // Duplicate detection
        colDuplicate: 'Duplikat',
        duplicateBadge: 'Duplikat',
        documentDuplicate: 'Dieses Dokument scheint ein Duplikat zu sein',
        markDuplicate: 'Als Duplikat markieren',
        unmarkDuplicate: 'Markierung entfernen',

        // Export data labels
        exportFilename: 'Dateiname',
        exportSupplier: 'Lieferant',
        exportInvoiceNo: 'Rechnungsnr.',
        exportInvoiceDate: 'Rechnungsdatum',
        exportTotalAmount: 'Gesamtbetrag',
        exportCurrency: 'W\u00e4hrung',
        exportVat: 'MwSt',
        exportSubtotal: 'Zwischensumme',
        exportLineItems: 'Positionen',
        exportExtractionStatus: 'Extraktionsstatus',
        exportUploadDate: 'Hochladedatum',
        exportStatusCompleted: 'Abgeschlossen',
        exportStatusProcessing: 'Wird verarbeitet',
        exportStatusPending: 'Ausstehend',
        exportStatusFailed: 'Fehlgeschlagen',
        exportStatusUnknown: 'Unbekannt',
        exportPeriod: 'Zeitraum',
        exportInvoiceCount: 'Rechnungsanzahl',
        exportSummarySheet: '\u00dcbersicht',
        exportNoData: 'Keine Rechnungen im ausgew\u00e4hlten Zeitraum gefunden.',
        exportFilenamePrefix: 'Ausgaben_',
        exportMonths: 'Januar,Februar,M\u00e4rz,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember',
    },
};
